export default "__VITE_ASSET__CSBgdVPN__"